import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SoftSwitch from "components/SoftSwitch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import logo from "assets/images/apna-thali-logo.png";
import loginImage from "assets/images/7015971.jpg";
import toast from "react-hot-toast";
import { setAuthSession } from "utils/authStorage";
// import { sendFirebaseTokenToServer, startFirebaseMessageListener } from "firebase";
// import { requestPermission, onMessageListener } from "../../../firebase";
 


function SignIn() {

  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const HandleSignIn = () => {

   
    fetch(`${process.env.REACT_APP_API}/api/v1/login/admin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password, hashKey: "27e5c4c5c3d45c02496e0d88918be3b7" }),
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.success) {
          setAuthSession({
            rememberMe,
            token: resp?.accessToken,
            userId: resp?.user?._id,
            userType: "SUPER_ADMIN",
          });
          navigate("/dashboard");
          return toast.success(resp?.message);
        }
        if (!resp.success) {
          if(typeof resp?.message !== "object"){
          return toast.error(resp?.message); 
          }
        }
      })
      .catch((err) => {
        return toast.error(err?.message);
      });

  };
  return (
    <CoverLayout
      title="Welcome back"
      description="Enter your email and password to sign in"
      image={loginImage}
      header={
        <SoftBox textAlign="center" mb={2}>
          <SoftBox
            component="img"
            src={logo}
            alt="Apna Thali"
            sx={{ width: "70%", maxWidth: 200, mb: 2 }}
          />
          <SoftTypography variant="h3" fontWeight="bold" color="info" textGradient>
            Welcome back
          </SoftTypography>
          <SoftTypography variant="body2" fontWeight="regular" color="text">
            Enter your email and password to sign in
          </SoftTypography>
        </SoftBox>
      }
    >
      <SoftBox
        component="form"
        role="form"
        onSubmit={(e) => {
          e.preventDefault();
          HandleSignIn();
        }}
      >
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Email or phone
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </SoftBox>
        
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Password
            </SoftTypography>
          </SoftBox>

          <SoftInput
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={{
              component: (
                <IconButton
                  type="button"
                  tabIndex={-1}
                  onClick={() => setShowPassword((v) => !v)}
                  size="small"
                  sx={{ color: "inherit", p: 0.2, mb:2}}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <Icon fontSize="small">
                    {showPassword ? "visibility_off" : "visibility"}
                  </Icon>
                </IconButton>
              ),
              direction: "right",
            }}
          />
        </SoftBox>
        <FormControlLabel
          control={
            <SoftSwitch
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              color="info"
            />
          }
          label={
            <SoftTypography variant="button" fontWeight="regular" component="span">
              Remember me
            </SoftTypography>
          }
          sx={{ ml: 0, userSelect: "none" }}
        />
        <SoftBox mt={4} mb={1}>
          <SoftButton type="submit" variant="gradient" color="info" fullWidth>
            sign in
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
